import { useMemo, useState } from 'react';
import { LifeBuoy } from 'lucide-react';
import { useAllTickets } from './useTickets';
import { TicketCard } from './TicketCard';

type TabKey = 'backlog' | 'resolved';

export function ImplementacoesPage() {
  const { data: tickets = [], isLoading } = useAllTickets();
  const [tab, setTab] = useState<TabKey>('backlog');

  const filtered = useMemo(() => {
    if (tab === 'backlog')
      return tickets.filter((t) => t.status === 'open' || t.status === 'in_progress');
    return tickets.filter((t) => t.status === 'resolved');
  }, [tickets, tab]);

  const counts = useMemo(
    () => ({
      backlog: tickets.filter((t) => t.status === 'open' || t.status === 'in_progress').length,
      resolved: tickets.filter((t) => t.status === 'resolved').length,
    }),
    [tickets],
  );

  return (
    <div>
      <div className="mb-6">
        <h1 className="font-brand text-2xl font-bold text-foreground">Implementações</h1>
        <p className="text-sm text-muted-foreground">
          Chamados abertos por colaboradores e clientes
        </p>
      </div>

      <div className="mb-4 flex gap-1 rounded-lg border border-border bg-white p-1">
        {[
          { key: 'backlog' as TabKey, label: 'Backlog', count: counts.backlog },
          { key: 'resolved' as TabKey, label: 'Resolvidos', count: counts.resolved },
        ].map((t) => (
          <button
            key={t.key}
            onClick={() => setTab(t.key)}
            className={`flex-1 rounded-md px-4 py-2 text-sm font-medium transition-colors ${
              tab === t.key
                ? 'bg-primary text-primary-foreground'
                : 'text-muted-foreground hover:bg-secondary hover:text-foreground'
            }`}
          >
            {t.label} <span className="opacity-70">({t.count})</span>
          </button>
        ))}
      </div>

      {isLoading ? (
        <div className="rounded-xl border border-border bg-white p-12 text-center text-muted-foreground">
          <p className="text-sm">Carregando chamados…</p>
        </div>
      ) : filtered.length === 0 ? (
        <div className="rounded-xl border border-border bg-white p-12 text-center text-muted-foreground">
          <LifeBuoy className="mx-auto mb-3 h-12 w-12 opacity-30" />
          <p className="text-sm font-medium">
            {tab === 'backlog' ? 'Nenhum chamado pendente' : 'Nenhum chamado resolvido ainda'}
          </p>
        </div>
      ) : (
        <div className="space-y-3">
          {filtered.map((ticket) => (
            <TicketCard key={ticket.id} ticket={ticket} />
          ))}
        </div>
      )}
    </div>
  );
}
